// import {
//   countries as countriesData,
//   timeZone,
// } from "../../../resources/LocationData";
import { useEffect, useState } from "react";
import Styles from "./locationStyle.module.css";
import { toast, ToastContainer } from "react-toastify";
import { MdEditNote } from "react-icons/md";
import {
  DatePicker,
  Select,
  Button,
  Form,
  Input,
  Checkbox,
} from "antd";

const ProjectInstallationDetailsComponent = ({ projectInstallationDetails, setProjectInstallationDetails, isApprover, approvalStage, siteStatus, setSiteStatus, isApproverView }) => {
  const [form] = Form.useForm();
  

  const submitForm = (isCompleted) => {
    if (isCompleted) {
      if (
        Object.values(projectInstallationDetails).filter((value) => value !== null)
          .length === Object.values(projectInstallationDetails).length
      ) {
        form.submit();
        setProjectInstallationDetails((prev) => ({
          ...prev,
          isSectionCompleted: true,
        }));
        // Submit the form
      } else {
        setProjectInstallationDetails((prev) => ({
          ...prev,
          isSectionCompleted: false,
        }));
        // Reset the checkbox in the form
        form.setFieldsValue({
          isSectionCompleted: false,
        });

        toast.error(
          "Please fill all the details before marking the section as completed."
        );
      }
    }
  };


  return (
    <div className={Styles[`main-div`]}>
      <div className={Styles["location-head-div"]}>
        <div>
          <span>
            {" "}
            {projectInstallationDetails?.isSectionCompleted && isApprover && isApproverView && (
              <Button
                className={Styles["edit-btn"]}
                disabled={!projectInstallationDetails?.isSectionCompleted || siteStatus === "Live" || siteStatus === "Pre Live" || approvalStage !== 'PendingApproval'}
                onClick={() => {
                  setProjectInstallationDetails((prev) => ({
                    ...prev,
                    isSectionCompleted: false,
                  }));
                  form.setFieldsValue({
                    isSectionCompleted: false,
                  });
                }}
              >
                {" "}
                <MdEditNote 
                  className={Styles["location-edit-icon"]}
                />{" "}
                Edit
              </Button>
            )}
          </span>
        </div>
      </div>

      <Form
        className={Styles["form-grid"]}
        form={form}
        initialValues={projectInstallationDetails}
        disabled={projectInstallationDetails?.isSectionCompleted || (approvalStage === "Approved") || (approvalStage === "PendingApproval" && isApprover === false)}
      >
        <Form.Item
          name="installCompany"
          label="Install Company"
          rules={[{ required: true, message: "Please input install company!" }]}
        >
           <Input
            onChange={(e) => {
              setProjectInstallationDetails((prev) => ({
                ...prev,
                installCompany: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>
        <Form.Item
          name="installPOC"
          label="Install POC"
          rules={[{ required: true, message: "Please input install POC!" }]}
        >
           <Input
            onChange={(e) => {
              setProjectInstallationDetails((prev) => ({
                ...prev,
                installPOC: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>

        <Form.Item
          name="installPOCEmail"
          label="Install POC Email"
          rules={[{ required: true, message: "Please input install POC Email!" }]}
        >
           <Input
            onChange={(e) => {
              setProjectInstallationDetails((prev) => ({
                ...prev,
                installPOCEmail: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>

        <Form.Item
          name="installPOCPhone"
          label="Install POC Phone"
          rules={[{ required: true, message: "Please input install POC Phone!" }]}
        >
          <Input
            onChange={(e) => {
              setProjectInstallationDetails((prev) => ({
                ...prev,
                installPOCPhone: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>

        <Form.Item
          name="installStartCommitDate"
          label="Install Start Commit Date"
          rules={[{ required: true, message: "Please input install start commit date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setProjectInstallationDetails(prev => ({
              ...prev,
              installStartCommitDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item
          name="installStartDate"
          label="Install Start Date"
          rules={[{ required: true, message: "Please input install start date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setProjectInstallationDetails(prev => ({
              ...prev,
              installStartDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

            <Form.Item
          name="installEndDate"
          label="Install End Date"
          rules={[{ required: true, message: "Please input install end date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setProjectInstallationDetails(prev => ({
              ...prev,
              installEndDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>





        {isApprover && isApproverView && <Form.Item className={Styles["full-width"]} name="isSectionCompleted" valuePropName="checked">
          <Checkbox
            disabled={
              Object.values(projectInstallationDetails).filter((value) => value !== null)
                .length /
                Object.values(projectInstallationDetails).length <
                1 || projectInstallationDetails?.isSectionCompleted
            }
            onChange={(e) => {
              submitForm(e.target.checked);
            }}
          >
            {" "}
            Verified and Completed.
          </Checkbox>
        </Form.Item>}
      </Form>
    </div>
  );
};
export default ProjectInstallationDetailsComponent;
